import styled from 'styled-components';

export const CctvLeftSideMenuStyle = styled.div`
  flex: 0 0 21rem;
  width: 21rem;
  height: 100%;
  height: 100vh;
  height: 100dvh;
  border-right: 1px solid var(--outline);
  display: flex;
  flex-direction: column;
  > .selectStream > div > ul > li {
    min-width: 100%;
  }
  > .cctvWrapperHidden {
    visibility: hidden;
    height: 0.1rem;
    width: 0.1rem;
    position: absolute;
    left: 0;
    top: 0;
  }
  .list {
    height: 30%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  .openFolder,
  .selectStream {
    padding: 0.25rem 0.5rem;
  }

  .selectStream {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    > div {
      flex-grow: 1;
    }
  }
  .bookmarkWrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0;
    padding-left: 0.5rem;
    gap: 0.5rem;
    border-bottom: 1px solid var(--outline);
    > .bookmark {
      all: unset;
      cursor: pointer;
      user-select: none;
      color: var(--text-tertiary);

      .material-symbols-rounded {
        font-size: 24px;
        width: 2rem;
        height: 2rem;
        display: flex;
        align-items: center;

        :hover {
          color: var(--selected-primary);
          font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
        }
      }

      &:hover {
        background-color: transparent;
      }
    }

    > span {
      cursor: pointer;
      user-select: none;
    }

    > :nth-child(2) {
      flex-grow: 1;
      > ul > li {
        width: inherit;
        max-width: none;
      }
    }
  }
  .menuWrapper {
    overflow-y: auto;
    height: calc(100% - 4rem);
    padding: 0.5rem;
    padding-bottom: 1rem;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
  &.hidden {
    display: none;
  }
  .broadcastControlWrapper {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 0.5rem;
    border-top: 1px solid var(--outline);
    background-color: var(--background-secondary);
  }
  .broadcastButton {
    all: unset;
    cursor: pointer;
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    font-weight: 600;
    text-align: center;
    user-select: none;
    transition: all 0.2s ease;
    white-space: nowrap;
    &.connectCheck {
      background-color: var(--filled-amber);
      color: var(--text-reverse);
    }
    &.idle {
      background-color: var(--filled-blue-light);
      color: var(--text-reverse);
    }
    &.playing {
      background-color: var(--filled-green);
      color: var(--text-reverse);
    }
    &.unavailable {
      background-color: var(--tonal);
      color: var(--text-secondary);
    }
    &.connecting {
      background-color: var(--filled-orange);
      color: var(--text-reverse);
    }
  }
  .volumeControl {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex: 1;
    .material-symbols-rounded {
      font-size: 20px;
      color: var(--text-secondary);
      flex-shrink: 0;
    }
    input[type='range'] {
      flex: 1;
      height: 0.25rem;
      background: var(--background-tertiary);
      border-radius: 0.125rem;
      outline: none;
      -webkit-appearance: none;
      appearance: none;
      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 1rem;
        height: 1rem;
        background: var(--selected-primary);
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.2s ease;
        &:hover {
          background: var(--selected-primary-hover);
          transform: scale(1.1);
        }
      }
      &::-moz-range-thumb {
        width: 1rem;
        height: 1rem;
        background: var(--selected-primary);
        border-radius: 50%;
        cursor: pointer;
        border: none;
        transition: all 0.2s ease;
        &:hover {
          background: var(--selected-primary-hover);
          transform: scale(1.1);
        }
      }
      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        &::-webkit-slider-thumb {
          cursor: not-allowed;
        }
        &::-moz-range-thumb {
          cursor: not-allowed;
        }
      }
    }
    .volumeValue {
      min-width: 2.5rem;
      text-align: center;
      font-size: 0.875rem;
      font-weight: 600;
      color: var(--text-secondary);
      flex-shrink: 0;
    }
    .slider-container {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      width: 100%;

      .material-symbols-rounded {
        font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
        font-size: 1rem;
        color: #888;
        width: 28px;
        text-align: center;
      }

      input[type='range'] {
        flex: 1;
        height: 6px;
      }

      .volume-value {
        min-width: 1.5rem;
        text-align: right;
        color: var(--text-tertiary);
      }
    }
  }
`;
